import s from "../../../helpers/service-helper.js";
import "react/jsx-runtime";
import "dayjs";
const b = async ({
  locationId: o,
  typeId: t,
  pickupTime: r,
  returnTime: n,
  customerInfo: e
}) => {
  const i = {
    "Content-Type": "application/json"
  }, p = JSON.stringify({
    locationId: o,
    typeId: t,
    pickupTime: r,
    returnTime: n,
    customerInfo: e
  });
  return s.httpPost("/v1/rentaltrailer/booking", {
    body: p,
    headers: i
  });
};
export {
  b as postTrailerRentalBooking
};
